<div class="mobile_version-backbutton">
    <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""></span>About TPL</a>
</div>

<section class="about" data-aos="fade-up">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 leftLogoDiv sticky_image">
                <img src="../../../assets/img/logo/new-logos/630x640px-about-us.png" alt=""
                    class="responsive-image aboutTPLlogo" style="    width: 100%;
                    height:100%;
                    object-fit: contain;">
            </div>
            <div class="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-2 content mobile_bg aboutCardContent" data-aos="fade-up"
                data-aos-delay="200">
                <div [innerHTML]="cmsContentData" class="section-contain"></div>
                <!-- <h4>About The League
                </h4> -->
                <!-- <div class="paragraph">
                    <p> <span class="boldText">Tennis Premier League (TPL)</span> is a pioneering initiative by <span
                            class="boldText">Skygoal Sports Private Limited,</span>
                        spearheaded by <span class="boldText">Mr. Kunal Thakkur</span> (former national-level tennis
                        player) and <span class="boldText">Mr. Mrunal Jain</span>
                        (entrepreneur and television actor). Since its inception in <span class="boldText">2018</span>,
                        the league has been committed
                        to
                        transforming tennis in India by bringing innovation, glamour, and entertainment to the sport.
                    </p>
                    <p>
                        Over the past six seasons, TPL has established itself as a <span class="boldText">revolutionary
                            platform for tennis</span>,
                        blending
                        top-notch competition with fan engagement with its innovative 25-point format. This December,
                        the
                        league will mark a historic milestone by becoming <span class="boldText">India’s 4th sporting
                            league to complete seven
                            successful seasons.</span>
                    </p>
                    <p>
                        Backed by the support of leading players, academies, and stakeholders, TPL has elevated tennis
                        to a
                        wider audience, taking the sport beyond elite clubs to the masses. With each passing season, it
                        has
                        provided young Indian talent the opportunity to compete alongside and learn from international
                        stars, making tennis more aspirational and accessible.
                    </p>
                    <p>
                        The <span class="boldText">franchise-based format,</span> city representation, and unique mix of
                        sport and entertainment have
                        made TPL one of the most exciting and fast-growing sporting properties in the country.
                    </p>
                    <p><span class="boldText">This season promises to be bigger and better, as India’s tennis stars and
                            international players
                            come
                            together once again for electrifying action on the court.</span></p>
                </div> -->
            </div>

        </div>
    </div>
</section>
<!-- <section class="pointsSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12 formatetitleText">
                <h4> 25-POINT Scoring FORMAT</h4>
                <p>The Tennis Premier League (TPL) has redefined tennis with its unique 25-point format, making every
                    point count and every match a spectacle.</p>
            </div>
            <div class="col-md-12 pointsListDiv">
                <ul class="pointsUl">
                    <li class="mainList">
                        <h6>Match Structure</h6>
                        <ul>
                            <li>
                                Each match consists of 4 Games:
                                <ol>
                                    <li>Women’s Singles </li>
                                    <li>Men’s Singles </li>
                                    <li>Mixed Doubles </li>
                                    <li>Men’s Doubles </li>
                                </ol>
                            </li>
                            <li>
                                Each Game is played to 25 Points.
                            </li>
                            <li>
                                Total per match = 100 Points.
                            </li>
                        </ul>
                    </li>
                    <li class="mainList">
                        <h6>League Structure </h6>
                        <ul>
                            <li>
                                8 Teams compete in the league.
                            </li>
                            <li>
                                Each team plays 5 matches → 500 Points in total.
                            </li>
                            <li>
                                The Top 4 Teams on the points table qualify for the Semi-Finals.
                            </li>
                            <li>
                                Semi-final winners battle in the Final to crown the champions.
                            </li>
                        </ul>
                    </li>
                    <li class="mainList">
                        <h6>Scoring System </h6>
                        <ul>
                            <li>
                                Every rally counts as 1 point.
                            </li>
                            <li>
                                There are no deuces, no advantages — just continuous play.
                            </li>
                            <li>
                                At the end of 25 rallies, the team with more points wins that game (e.g., 14–11).
                            </li>
                            <li>
                                The accumulated score across all 4 games decides the match result.
                            </li>
                        </ul>
                    </li>
                </ul>
                <div class="notesDiv">
                    The 25-point format ensures that tennis is not only more thrilling for fans but also more
                    competitive
                    for players, making TPL a game-changer in Indian sports entertainment.
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- <section class="aboutSkyGoal">
    <div class="container">
        <div class="row">
            <div class="col-md-12 sportmaindiv">
                <div class="sportcard">
                    <h3>SKYGOAL SPORTS </h3>
                    <p><span class="boldText">Skygoal Sports Private Limited</span> is the proud organizer of the Tennis
                        Premier League. Founded with
                        a
                        vision to <span class="boldText">popularize tennis across India</span>, the company is led by
                        Mr. Kunal Thakkur and Mr. Mrunal
                        Jain, who have successfully combined their passion for sport and strong industry experience to
                        create one of India’s most premium sporting properties.</p>
                    <p>
                        Since 2018, Skygoal Sports has consistently innovated to make TPL not just a tennis tournament,
                        but
                        a <span class="boldText">celebration of sport, entertainment, and youth engagement,</span>
                        placing tennis firmly in India’s
                        evolving sporting ecosystem.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section> -->
<div class="mainBgDiv">
    <section class="mobile_founder_slider">
        <div class="founder_slider swiper" data-aos="fade-up" data-aos-delay="100">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 mainb-div">
                        <h4 class="slider_heading">Founders & Advisors</h4>
                        <swiper class="swiper-container" fxFlex="auto" [config]="config" [disabled]="disabled"
                            (indexChange)="onIndexChange($event)"
                            (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                            (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                            <div class="swiper-slide" *ngFor="let advisor of boardAndAdvisorsData">
                                <div class="founder_item">
                                    <img [src]="advisor?.image" class="founder-img" alt="">
                                    <h3>{{ advisor?.name }}</h3>
                                    <h5>{{ advisor?.designation }}</h5>
                                    <p><i class="bx bxs-quote-alt-left quote-icon-left"></i>
                                        {{ advisor?.quote }}
                                    </p>
                                    <h6>
                                        {{ advisor?.description }}
                                    </h6>
                                </div>
                            </div>
                        </swiper>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<section class="tplsStanding-section" id="teamSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12 standingMain">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>TPL Team Standings</h2>
                    </div>
                    <div class="right-heading">
                        <button (click)="onDownloadClick('bottom')">KNOW MORE</button>
                    </div>
                </div>
                <div class="tplstandingTable">
                    <table>
                        <thead>
                            <tr>
                                <th class="firstTd">name</th>
                                <th>played</th>
                                <th>w</th>
                                <th>L</th>
                                <th>d</th>
                                <th>points</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let team of pointsTableDataDetails; let i = index">
                                <td class="firstTd">
                                    <div class="teamStandingDiv">
                                        <div class="no">{{ i + 1 }}</div>
                                        <div class="staingDetails">
                                            <img src={{team.image_src}} alt="">
                                            <h4>{{ team.name }}</h4>
                                        </div>
                                    </div>
                                </td>
                                <td>{{ team.played }}</td>
                                <td>{{ team.win }}</td>
                                <td>{{ team.lose }}</td>
                                <td>{{ team.draw }}</td>
                                <td class="points">{{ team.points }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="team-section" id="teamSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>TPL Teams</h2>
                    </div>
                    <div class="right-heading">
                        <button routerLink="/teams">VIEW ALL</button>
                    </div>
                </div>
                <div class="slider-main">
                    <swiper class="swiper-container  " fxFlex="auto" [config]="teamSlider">
                        <div *ngFor="let team of teamList" class="swiper-slide  ">
                            <div class="main-slider">
                                <div class="news-image">
                                    <img src="{{team.logoImage}}" alt="">
                                </div>
                                <div class="main-title">
                                    <h4>{{team.name}} </h4>
                                </div>
                            </div>
                        </div>
                    </swiper>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="sponser-section" id="sponserSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>Sponsors</h2>
                    </div>
                    <div class="right-heading">
                        <button routerLink="/sponsors">VIEW ALL</button>
                    </div>
                </div>
                <div class="slider-main" *ngFor="let group of groupedSponsors; let i = index">
                    <swiper class="swiper-container  " fxFlex="auto" [config]="sponserSlider">
                        <div *ngFor="let sponsor of group.sponsors" class="swiper-slide"
                            [title]="sponsor.title || sponsor.brandName || sponsor.name">
                            <a *ngIf="hasSponsorLink(sponsor); else sponsorLogoCard" [href]="getSponsorLink(sponsor)"
                                target="_blank" rel="noopener noreferrer" class="sponsor-card-link">
                                <div class="main-slider">
                                    <div class="news-image">
                                        <img src="{{sponsor.photo}}"
                                            alt="{{ sponsor.title || sponsor.brandName || sponsor.name }}">
                                    </div>
                                </div>
                            </a>
                            <ng-template #sponsorLogoCard>
                            <div class="main-slider">
                                <div class="news-image">
                                    <img src="{{sponsor.photo}}"
                                        alt="{{ sponsor.title || sponsor.brandName || sponsor.name }}">
                                </div>
                            </div>
                            </ng-template>
                        </div>
                    </swiper>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="news-section" id="newsSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>Media</h2>
                    </div>
                    <div class="right-heading">
                        <button routerLink="/media">VIEW ALL</button>
                    </div>
                </div>
                <div class="slider-main">
                    <swiper class="swiper-container  " fxFlex="auto" [config]="newsSlider">
                        <div *ngFor="let news of tplNews" class="swiper-slide  ">
                            <div class="main-slider">
                                <div class="news-image">
                                    <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'" [lazyLoad]="news.src"
                                        alt="">
                                </div>
                                <div class="main-top">
                                    <div class="meidaleft">
                                        <img src="../../../assets/images/aboutUs/newsImage.png" alt="">
                                        <div class="textName">
                                            <span>{{ news.channelName }}</span>
                                        </div>
                                    </div>
                                    <div class="meidaright">
                                        {{ news.createdAt | date:'dd MMM yyyy' }}
                                    </div>
                                </div>
                                <div class="main-title">
                                    <h4> {{news.heading}} </h4>
                                    <div class="bttuon">
                                        <a [href]="news.link" target="_blank">
                                            <img src="../../../assets/images/aboutUs/buttonGo.svg" alt="">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="feature-section" id="featuredThisWeekSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>Featured This Week</h2>
                    </div>
                    <div class="right-heading">
                        <button (click)="onDownloadClick('bottom')">VIEW ALL</button>
                    </div>
                </div>
                <div class="slider-main">
                    <swiper class="swiper-container  " fxFlex="auto" [config]="featureListSlider">
                        <div *ngFor="let feature of featureList" class="swiper-slide  ">
                            <a [href]="feature?.link" target="_blank">
                                <div class="main-slider">
                                    <div class="overly-color"></div>
                                    <img [src]="feature?.photo" alt="">
                                    <div class="feature-div-details">
                                        <div class="footerDiv">
                                            <h6 *ngIf="feature?.date">
                                                {{feature?.date | ordinalDate}}
                                            </h6>
                                            <h5>
                                                {{feature?.title}}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </swiper>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>
        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>
        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>
